/**
 * Tiny in-flight/response cache for public settings endpoints.
 *
 * These endpoints (site settings, feature flags, hero media, charter
 * companies) are read by many components. Without dedupe each mount fires its
 * own request - we measured /api/settings/site being fetched 7 times on a
 * single home page load, with several aborted, which delayed the header logo
 * and menu. One promise per URL fixes that.
 */
const cache = new Map();

export const fetchJsonCached = (url) => {
  if (!cache.has(url)) {
    const promise = fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Request failed: ${res.status}`);
        return res.json();
      })
      .catch((error) => {
        // never cache a failure - allow a later retry
        cache.delete(url);
        throw error;
      });
    cache.set(url, promise);
  }
  return cache.get(url);
};

/** Call after a settings save so the public site picks up new values. */
export const invalidateSettingsCache = (url) => {
  if (url) cache.delete(url);
  else cache.clear();
};
